// extracted by mini-css-extract-plugin
export default {"recipe":"recipe_recipe__Xyo8l","image":"recipe_image__9oGP1","calories":"recipe_calories__mcvYy"};